import { render, staticRenderFns } from "./UploadBtn.vue?vue&type=template&id=4e31c081&scoped=true&"
import script from "./UploadBtn.vue?vue&type=script&lang=js&"
export * from "./UploadBtn.vue?vue&type=script&lang=js&"
import style0 from "./UploadBtn.vue?vue&type=style&index=0&id=4e31c081&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e31c081",
  null
  
)

component.options.__file = "UploadBtn.vue"
export default component.exports